import { all } from 'redux-saga/effects';

const totalSagas = function* root() {
  yield all([]);
};
export { totalSagas };
